const RecordSharingModeNames = {
  DISABLED: 'DISABLED',
  ADHOC: 'ADHOC',
  AUTO: 'AUTO',
}

export default RecordSharingModeNames
